import React from "react";
import { Pencil, Trash2 } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/ui/table";
import { Card } from "../../components/ui/card";
import { ContentLayout } from "../../components/admin-panel/content-layout";
import Pagination from "../../components/Pagination";
import DeleteModal from "../../components/deleteModal";
import ModalPopUpCompany from "../../components/AddAdmin";

const adminData = [
  {
    id: "1",
    name: "Fenish Desai",
  },
  {
    id: "2",
    name: "Ashish Kakadiya",
  },
  {
    id: "3",
    name: "Rushikesh Bhayani",
  },
];

const Company = () => {
  return (
    <ContentLayout>
      <Card className="grid gap-5">
        <div className="flex items-center justify-between">
          <h1 className="font-semibold text-xl">Company</h1>
          {/* <ModalPopUpCompany /> */}
        </div>
        <Table className="rounded-lg overflow-hidden">
          <TableHeader>
            <TableRow className="bg-primary hover:bg-primary text-white">
              <TableHead className="w-[100px] text-white">No.</TableHead>
              <TableHead className="text-white">Name</TableHead>
              <TableHead className="w-14 text-center text-white">
                Action
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {adminData.map((adminData) => (
              <TableRow key={adminData.adminData}>
                <TableCell>{adminData.id}</TableCell>
                <TableCell>{adminData.name}</TableCell>

                <TableCell className="w-14">
                  <div className="flex items-center justify-center gap-2">
                    <div className="border rounded-md p-1 hover:bg-primary hover:border-[#7064E9] duration-200 cursor-pointer">
                      <Pencil className="h-4 w-4" />
                    </div>
                    {/* <div className="group border rounded-md p-1 border-destructive hover:bg-destructive duration-200 cursor-pointer">
                <Trash2 className="w-4 h-4 text-destructive group-hover:text-white" />
              </div> */}
                    <DeleteModal />
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <div className="flex justify-end items-center">
          <Pagination />
        </div>
      </Card>
    </ContentLayout>
  );
};

export default Company;
